import { VendingStatus } from "../../shared-gen/Vending/Status/VendingStatus";
import { VmcState } from "../../shared-gen/Vending/Status/VmcState";
import { CartFun } from "../model/orders/cart.fun";
import { MenuFun } from "../model/menus/menu.fun";
import { Currency } from "../../shared-gen/Model/Utils/Currency";

export class VendingStatusFun {

    /**
     * Returns an offline vending status.
     * Can be used when the server can not be reached.
     */
    static offline(): VendingStatus {
        return {
            PriceList: null as any, //PriceListFun.createNew(''),
            Currency: Currency.EUR,
            VmcState: VmcState.Intervention,
            Order: null as any,
            LastFinishedOrder: null as any,
            IsCupPlaced: false,
            ShowRemoveChange: false,
            ShowRefund: false,
            Cart: CartFun.createNew(),
            LastVoucher: null as any,
            Notification: null as any,
            IsUserInactive: false
        }
    }

}
